import React, { FC, Fragment } from 'react';
import moment from 'moment';
import { NextPaymentDateStatusProps } from './props';
import './styles.scss';

export const NextPaymentDateStatus: FC<NextPaymentDateStatusProps> = ({
  label = 'Next payment date',
  nextPaymentDate,
}) => {
  return (
    <Fragment>
      <span className="plans-next-payment-date__label">{label}</span>
      <span className="plans-next-payment-date__value">{moment(nextPaymentDate).format('DD MMM YYYY')}</span>
    </Fragment>
  );
};
